// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"538":"b4446a14","787":"a38309ad","850":"ef741184"}[chunkId] + ".chunk.js";
};